import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
} from "@mui/material";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { getAccounts } from "../../api/groupsApi/groupsApi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetFileLocationDataById,
  SaveFileLocationData,
} from "../../api/fileLocationApi/fileLocationApi";
import {
  FileLocationContextModel,
  FileLocationModel,
} from "../../types/FileLocationModel";
import { useSnackbar } from "../Common/SnackbarContext";
import { DecryptPassword, EncryptPassword } from "../../api/commonApi";
import LocalStorageUtil from "../../utils/localStorage";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const CreateNew: React.FC = () => {
  const [value, setValue] = useState(0);
  const [ftpFolderId, setFtpFolderId] = useState(0);
  const [backUpftpFolderId, setBackUpftpFolderId] = useState(0);
  const [_fileLocationType, set_FileLocationType] = useState("");// NOSONAR
  const [valueBackUpNetwork, setValueBackUpNetwork] = useState(0);
  const [valueBackUpFTP, setValueBackUpFTP] = useState(0);
  const [showNetworkBackupTab, setShowNetworkBackupTab] = useState(false);
  const [showFTPBackupTab, setShowFTPBackupTab] = useState(false);
  const { setLoading } = useLoader();
  const [accountData, setAccountData] = useState<readonly number[]>([]);
  const location = useLocation();
  const action = location.state?.action ?? {};
  const rowData = location.state?.rowData ?? {};
  const [data, setData] = useState<any>([]);

  // Tab1 Network Folder
  const [parentNetworkCustomer, setParentNetworkCustomer] = useState("");
  const [parentNetworkDisplayName, setParentNetworkDisplayName] = useState("");
  const [parentNetworkUNCPath, setParentNetworkUNCPath] = useState("");

  // Tab 1.1 Network Folder backup folder
  const [tab1NetworkCustomer, setTab1NetworkCustomer] = useState("");
  const [tab1NetworkUNCPath, setTab1NetworkUNCPath] = useState("");

  // Tab 1.2 FTP Location backup folder
  const [tab1FTPBackUpCustomer, setTab1FTPBackUpCustomer] = useState("");
  const [tab1FTPBackUpDisplayName, setTab1FTPBackUpDisplayName] = useState("");
  const [tab1FTPBackUpServerName, setTab1FTPBackUpServerName] = useState("");
  const [tab1FTPBackUpLocation, setTab1FTPBackUpLocation] = useState("");
  const [tab1FTPBackUpPort, setTab1FTPBackUpPort] = useState("");
  const [tab1FTPBackUpProtocol, setTab1FTPBackUpProtocol] = useState("");
  const [tab1FTPBackUpUserName, setTab1FTPBackUpUserName] = useState("");
  const [tab1FTPBackUpPassword, setTab1FTPBackUpPassword] = useState("");

  // Tab2 FTP Location
  const [parentFTPCustomer, setParentFTPCustomer] = useState("");
  const [parentFTPDisplayName, setParentFTPDisplayName] = useState("");
  const [parentFTPServerName, setParentFTPServerName] = useState("");
  const [parentFTPLocation, setParentFTPLocation] = useState("");
  const [parentFTPPort, setParentFTPPort] = useState("");
  const [parentFTPProtocol, setParentFTPProtocol] = useState("");
  const [parentFTPUserName, setParentFTPUserName] = useState("");
  const [parentFTPPassword, setParentFTPPassword] = useState("");

  // Tab 2.1 Network Folder backup folder
  const [tab2NetworkBackUpCustomer, setTab2NetworkBackUpCustomer] =
    useState("");
  const [tab2NetworkBackUpUNCPath, setTab2NetworkBackUpUNCPath] = useState("");

  // Tab 2.2 FTP Location backup folder
  const [_tab2FTPBackUpCustomer, set_Tab2FTPBackUpCustomer] = useState("");// NOSONAR
  const [tab2FTPBackUpDisplayName, setTab2FTPBackUpDisplayName] = useState("");
  const [tab2FTPBackUpServerName, setTab2FTPBackUpServerName] = useState("");
  const [tab2FTPBackUpLocation, setTab2FTPBackUpLocation] = useState("");
  const [tab2FTPBackUpPort, setTab2FTPBackUpPort] = useState("");
  const [tab2FTPBackUpProtocol, setTab2FTPBackUpProtocol] = useState("");
  const [tab2FTPBackUpUserName, setTab2FTPBackUpUserName] = useState("");
  const [tab2FTPBackUpPassword, setTab2FTPBackUpPassword] = useState("");

  const [errors, setErrors] = useState<{
    parentNetworkCustomerError?: string;
    parentNetworkDisplayNameError?: string;
    parentNetworkUNCPathError?: string;
    tab1NetworkBackUpCustomerError?: string;
    tab1NetworkBackUpUNCPathError?: string;
    tab1FTPBackUpCustomerError?: string;
    tab1FTPBackUpDisplayNameError?: string;
    tab1FTPBackUpServerNameError?: string;
    tab1FTPBackUpLocationError?: string;
    tab1FTPBackUpPortError?: string;
    tab1FTPBackUpProtocolError?: string;
    tab1FTPBackUpUserNameError?: string;
    tab1FTPBackUpPasswordError?: string;
    parentFTPCustomerError?: string;
    parentFTPDisplayNameError?: string;
    parentFTPServerNameError?: string;
    parentFTPLocationError?: string;
    parentFTPPortError?: string;
    parentFTPProtocolError?: string;
    parentFTPUserNameError?: string;
    parentFTPPasswordError?: string;
    tab2NetworkBackUpCustomerError?: string;
    tab2NetworkBackUpUNCPathError?: string;
    tab2FTPBackUpCustomerError?: string;
    tab2FTPBackUpDisplayNameError?: string;
    tab2FTPBackUpServerNameError?: string;
    tab2FTPBackUpLocationError?: string;
    tab2FTPBackUpPortError?: string;
    tab2FTPBackUpProtocolError?: string;
    tab2FTPBackUpUserNameError?: string;
    tab2FTPBackUpPasswordError?: string;
  }>({});
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    accountName: data[0]?.accountName ?? "",
    groupName: data[0]?.groupName ?? "",
    groupType: data[0]?.groupType ?? "",
    contextName: data[0]?.contextName ?? "",
  });
  const navigation = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setParentNetworkDisplayName("");
    setParentNetworkUNCPath("");
    setTab1NetworkCustomer("");
    setTab1NetworkUNCPath("");
    setTab1FTPBackUpCustomer("");
    setTab1FTPBackUpDisplayName("");
    setTab1FTPBackUpServerName("");
    setTab1FTPBackUpLocation("");
    setTab1FTPBackUpPort("");
    setTab1FTPBackUpProtocol("");
    setTab1FTPBackUpUserName("");
    setTab1FTPBackUpPassword("");
    setParentFTPDisplayName("");
    setParentFTPServerName("");
    setParentFTPLocation("");
    setParentFTPPort("");
    setParentFTPProtocol("");
    setParentFTPUserName("");
    setParentFTPPassword("");
    setTab2NetworkBackUpCustomer("");
    setTab2NetworkBackUpUNCPath("");
    set_Tab2FTPBackUpCustomer("");
    setTab2FTPBackUpDisplayName("");
    setTab2FTPBackUpServerName("");
    setTab2FTPBackUpLocation("");
    setTab2FTPBackUpPort("");
    setTab2FTPBackUpProtocol("");
    setTab2FTPBackUpUserName("");
    setTab2FTPBackUpPassword("");
    setErrors({});
  };

  const handleChangeBackUpNetworkTab = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValueBackUpNetwork(newValue);
    setTab1NetworkCustomer("");
    setTab1NetworkUNCPath("");
    setTab1FTPBackUpCustomer("");
    setTab1FTPBackUpDisplayName("");
    setTab1FTPBackUpServerName("");
    setTab1FTPBackUpLocation("");
    setTab1FTPBackUpPort("");
    setTab1FTPBackUpProtocol("");
    setTab1FTPBackUpUserName("");
    setTab1FTPBackUpPassword("");
  };

  const handleChangeBackUpFTPTab = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValueBackUpFTP(newValue);
    setTab2NetworkBackUpCustomer("");
    setTab2NetworkBackUpUNCPath("");
    set_Tab2FTPBackUpCustomer("");
    setTab2FTPBackUpDisplayName("");
    setTab2FTPBackUpServerName("");
    setTab2FTPBackUpLocation("");
    setTab2FTPBackUpPort("");
    setTab2FTPBackUpProtocol("");
    setTab2FTPBackUpUserName("");
    setTab2FTPBackUpPassword("");
  };

  const handleNetworkBackupTabCheck = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowNetworkBackupTab(event.target.checked);
  };

  const handleFTPBackupTabCheck = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowFTPBackupTab(event.target.checked);
  };

  const getAllAccountsName = async () => {
    setLoading(true);
    const payload = {
      contextName: LocalStorageUtil.getItem("contextName") ?? "",
    };
    try {
      const data = await getAccounts(payload);
      setAccountData(data);
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  //Tab 1 Network Folder Customer Dropdown Change
  const handleParentNetworkCustomerDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setParentNetworkCustomer(value);
  };

  const handleTab1NetworkBackUpDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTab1NetworkCustomer(value);
  };

  const handleTab1FtpBackUpDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTab1FTPBackUpCustomer(value);
  };

  const handelTab1FtpProtocolChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTab1FTPBackUpProtocol(value);
  };

  //Tab 2 FTP Location Customer Dropdown Change
  const handleParentFTPCustomerDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setParentFTPCustomer(value);
  };

  const handleTab2NetworkBackUpDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTab2NetworkBackUpCustomer(value);
  };

  const handleTab2FtpBackUpDropdownChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    set_Tab2FTPBackUpCustomer(value);
  };

  const handelParentProtocolChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setParentFTPProtocol(value);
  };

  const handelTab2FtpProtocolChange = (event: any) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setTab2FTPBackUpProtocol(value);
  };

  useEffect(() => {
    getAllAccountsName();
    if (action === "Edit") {
      getFileLocationData();
      setParentNetworkCustomer(LocalStorageUtil.getItem("contextName") ?? "");
      setParentFTPCustomer(LocalStorageUtil.getItem("contextName") ?? "");
      set_Tab2FTPBackUpCustomer(LocalStorageUtil.getItem("contextName") ?? "");
    } else {
      setParentNetworkCustomer("");
      setParentFTPCustomer("");
      set_Tab2FTPBackUpCustomer("");
    }
  }, []);

  // Helper: Validate Network Folder Tab (Tab 1)
const validateNetworkFolderTab = ({
  parentNetworkCustomer,
  parentNetworkDisplayName,
  parentNetworkUNCPath,
  showNetworkBackupTab,
  valueBackUpNetwork,
  ftpFolderId,
  tab1NetworkCustomer,
  tab1NetworkUNCPath,
  tab1FTPBackUpCustomer,
  tab1FTPBackUpDisplayName,
  tab1FTPBackUpServerName,
  tab1FTPBackUpLocation,
  tab1FTPBackUpPort,
  tab1FTPBackUpProtocol,
  tab1FTPBackUpUserName,
  tab1FTPBackUpPassword,
}: any) => {
  const errors: any = {};

  // Helper to check required fields
  const checkRequired = (fields: { value: any; errorKey: string; message: string }[]) => {
    fields.forEach(({ value, errorKey, message }) => {
      if (!value) errors[errorKey] = message;
    });
  };

  // Main Network Folder fields
  checkRequired([
    { value: parentNetworkCustomer, errorKey: "parentNetworkCustomerError", message: "Customer is required" },
    { value: parentNetworkDisplayName, errorKey: "parentNetworkDisplayNameError", message: "Display Name is required" },
    { value: parentNetworkUNCPath, errorKey: "parentNetworkUNCPathError", message: "UNC Path is required" },
  ]);

  // Backup tab fields
  if (showNetworkBackupTab) {
    if (valueBackUpNetwork === 0) {
      if (ftpFolderId === 0 && !parentNetworkCustomer)
        errors.tab1NetworkBackUpCustomerError = "Customer is required";
      checkRequired([
        { value: tab1NetworkUNCPath, errorKey: "tab1NetworkBackUpUNCPathError", message: "UNC Path is required" },
      ]);
    } else if (valueBackUpNetwork === 1) {
      if (ftpFolderId === 0 && !parentNetworkCustomer)
        errors.tab1FTPBackUpCustomerError = "Customer is required";
      checkRequired([
        { value: tab1FTPBackUpDisplayName, errorKey: "tab1FTPBackUpDisplayNameError", message: "Display Name is required" },
        { value: tab1FTPBackUpServerName, errorKey: "tab1FTPBackUpServerNameError", message: "Server Name is required" },
        { value: tab1FTPBackUpLocation, errorKey: "tab1FTPBackUpLocationError", message: "Location is required" },
        { value: tab1FTPBackUpPort, errorKey: "tab1FTPBackUpPortError", message: "Port is required" },
        { value: tab1FTPBackUpProtocol, errorKey: "tab1FTPBackUpProtocolError", message: "Protocol is required" },
        { value: tab1FTPBackUpUserName, errorKey: "tab1FTPBackUpUserNameError", message: "User Name is required" },
        { value: tab1FTPBackUpPassword, errorKey: "tab1FTPBackUpPasswordError", message: "Password is required" },
      ]);
    }
  }

  return errors;
};

// Helper: Validate FTP Location Tab (Tab 2)
const validateFTPTab = ({
  ftpFolderId,
  parentFTPCustomer,
  parentFTPDisplayName,
  parentFTPServerName,
  parentFTPLocation,
  parentFTPPort,
  parentFTPProtocol,
  parentFTPUserName,
  parentFTPPassword,
  showFTPBackupTab,
  valueBackUpFTP,
  tab2NetworkBackUpCustomer,
  tab2NetworkBackUpUNCPath,
  parentFTPCustomerForBackup,
  tab2FTPBackUpDisplayName,
  tab2FTPBackUpServerName,
  tab2FTPBackUpLocation,
  tab2FTPBackUpPort,
  tab2FTPBackUpProtocol,
  tab2FTPBackUpUserName,
  tab2FTPBackUpPassword,
}: any) => {
  const errors: any = {};

  // Helper to check required fields
  const checkRequired = (fields: { value: any; errorKey: string; message: string }[]) => {
    fields.forEach(({ value, errorKey, message }) => {
      if (!value) errors[errorKey] = message;
    });
  };

  // Main FTP fields
  if (ftpFolderId === 0 && !parentFTPCustomer)
    errors.parentFTPCustomerError = "Customer is required";
  checkRequired([
    { value: parentFTPDisplayName, errorKey: "parentFTPDisplayNameError", message: "Display Name is required" },
    { value: parentFTPServerName, errorKey: "parentFTPServerNameError", message: "Server Name is required" },
    { value: parentFTPLocation, errorKey: "parentFTPLocationError", message: "Location is required" },
    { value: parentFTPPort, errorKey: "parentFTPPortError", message: "Port is required" },
    { value: parentFTPProtocol, errorKey: "parentFTPProtocolError", message: "Protocol is required" },
    { value: parentFTPUserName, errorKey: "parentFTPUserNameError", message: "User Name is required" },
    { value: parentFTPPassword, errorKey: "parentFTPPasswordError", message: "Password is required" },
  ]);

  // Backup tab fields
  if (showFTPBackupTab) {
    if (valueBackUpFTP === 0) {
      if (ftpFolderId === 0 && !parentFTPCustomer)
        errors.tab2NetworkBackUpCustomerError = "Customer is required";
      checkRequired([
        { value: tab2NetworkBackUpUNCPath, errorKey: "tab2NetworkBackUpUNCPathError", message: "UNC Path is required" },
      ]);
    } else if (valueBackUpFTP === 1) {
      checkRequired([
        { value: parentFTPCustomer, errorKey: "tab2FTPBackUpCustomerError", message: "Customer is required" },
        { value: tab2FTPBackUpDisplayName, errorKey: "tab2FTPBackUpDisplayNameError", message: "Display Name is required" },
        { value: tab2FTPBackUpServerName, errorKey: "tab2FTPBackUpServerNameError", message: "Server Name is required" },
        { value: tab2FTPBackUpLocation, errorKey: "tab2FTPBackUpLocationError", message: "Location is required" },
        { value: tab2FTPBackUpPort, errorKey: "tab2FTPBackUpPortError", message: "Port is required" },
        { value: tab2FTPBackUpProtocol, errorKey: "tab2FTPBackUpProtocolError", message: "Protocol is required" },
        { value: tab2FTPBackUpUserName, errorKey: "tab2FTPBackUpUserNameError", message: "User Name is required" },
        { value: tab2FTPBackUpPassword, errorKey: "tab2FTPBackUpPasswordError", message: "Password is required" },
      ]);
    }
  }

  return errors;
};

  const handleCreate = () => {
    setErrors({});
    let newErrors: any = {};
  // Check for duplicate display name in Network Folder tab
  if (
    value === 0 &&
    showNetworkBackupTab &&
    valueBackUpNetwork === 1 && // FTP Location backup tab
    tab1FTPBackUpDisplayName.trim() !== "" &&
    tab1FTPBackUpDisplayName.trim().toLowerCase() === parentNetworkDisplayName.trim().toLowerCase()
  ) {
    showSnackbar("Sorry, Display Name already exists", true);
    return;
  }

  // Check for duplicate display name in FTP Location tab
  if (
    value === 1 &&
    showFTPBackupTab &&
    valueBackUpFTP === 1 && // FTP Location backup tab
    tab2FTPBackUpDisplayName.trim() !== "" &&
    tab2FTPBackUpDisplayName.trim().toLowerCase() === parentFTPDisplayName.trim().toLowerCase()
  ) {
    showSnackbar("Sorry, Display Name already exists", true);
    return;
  }
    if (value === 0) {
      newErrors = validateNetworkFolderTab({
        parentNetworkCustomer,
        parentNetworkDisplayName,
        parentNetworkUNCPath,
        showNetworkBackupTab,
        valueBackUpNetwork,
        ftpFolderId,
        tab1NetworkCustomer,
        tab1NetworkUNCPath,
        tab1FTPBackUpCustomer,
        tab1FTPBackUpDisplayName,
        tab1FTPBackUpServerName,
        tab1FTPBackUpLocation,
        tab1FTPBackUpPort,
        tab1FTPBackUpProtocol,
        tab1FTPBackUpUserName,
        tab1FTPBackUpPassword,
      });
    } else if (value === 1) {
      newErrors = validateFTPTab({
        ftpFolderId,
        parentFTPCustomer,
        parentFTPDisplayName,
        parentFTPServerName,
        parentFTPLocation,
        parentFTPPort,
        parentFTPProtocol,
        parentFTPUserName,
        parentFTPPassword,
        showFTPBackupTab,
        valueBackUpFTP,
        tab2NetworkBackUpCustomer,
        tab2NetworkBackUpUNCPath,
        parentFTPCustomerForBackup: parentFTPCustomer,
        tab2FTPBackUpDisplayName,
        tab2FTPBackUpServerName,
        tab2FTPBackUpLocation,
        tab2FTPBackUpPort,
        tab2FTPBackUpProtocol,
        tab2FTPBackUpUserName,
        tab2FTPBackUpPassword,
      });
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      saveFileLocationData();
    }
  };

  const handleConfirmDialogClose = (confirm: boolean) => {
    setConfirmDialogOpen(false);
    if (confirm) {
      // Add your logic here if needed
      navigate("/FileLocation"); // Redirect to FileLocation
    } else {
      setConfirmDialogOpen(false);
    }
  };

  const handelCancel = () => {
    setConfirmDialogOpen(true);
  };

  // Helper to set backup tab values for Network
  const setNetworkBackupTabValues = (data: any) => {
    if (data?.enableBackup) {
      setShowNetworkBackupTab(true);
      if (data?.listEmailTemplateModel[0].fileLocationType === 1) {
        setValueBackUpNetwork(0);
      } else {
        setValueBackUpNetwork(1);
      }
    } else {
      setShowNetworkBackupTab(false);
    }
    setParentNetworkCustomer(LocalStorageUtil.getItem("contextName") ?? "");
    setParentNetworkDisplayName(data?.folderName);
    setParentNetworkUNCPath(data?.location);
  };

  // Helper to set backup tab values for FTP
  const setFTPBackupTabValues = (data: any) => {
    setParentFTPCustomer(LocalStorageUtil.getItem("contextName") ?? "");
    setParentFTPDisplayName(data?.folderName);
    setParentFTPServerName(data?.serverName ?? "");
    setParentFTPLocation(data?.location ?? "");
    setParentFTPPort(data?.port ?? "");
    setParentFTPProtocol(data?.protocol === 2 ? "SFTP" : "FTP");
    setParentFTPPassword(DecryptPassword(data?.password));
  };

  // Helper to set backup details from listEmailTemplateModel
  const setBackupDetailsFromList = (list: any[]) => {
    if (!list || list.length === 0) {
      setShowFTPBackupTab(false);
      setBackUpftpFolderId(0);
      return;
    }
    handleFTPBackupTabCheck({
      target: { checked: true },
    } as React.ChangeEvent<HTMLInputElement>);

    if (list[0].fileLocationType === 1) {
      setValueBackUpFTP(0);
    } else {
      setValueBackUpFTP(1);
    }

    // Tab 1.1 Network Folder Backup
    setTab1NetworkUNCPath(list[0].location);
    setBackUpftpFolderId(list[0].ftpFolderId);

    // Tab 1.2 FTP Location Backup
    setTab1FTPBackUpDisplayName(list[0].folderName ?? "");
    setTab1FTPBackUpServerName(list[0].serverName ?? "");
    setTab1FTPBackUpLocation(list[0].location ?? "");
    setTab1FTPBackUpPort(list[0].port ?? "");
    setTab1FTPBackUpProtocol(list[0].protocol === 2 ? "SFTP" : "FTP");
    setTab1FTPBackUpUserName(list[0].userName ?? "");
    setTab1FTPBackUpPassword(DecryptPassword(list[0].password ?? ""));

    // Tab 2.1 Network Folder Backup
    setParentNetworkCustomer(LocalStorageUtil.getItem("contextName") ?? "");
    setTab2NetworkBackUpUNCPath(list[0].location ?? "");

    // Tab 2.2 FTP Location Backup
    setTab2FTPBackUpDisplayName(list[0].folderName ?? "");
    setTab2FTPBackUpServerName(list[0].serverName ?? "");
    setTab2FTPBackUpLocation(list[0].location ?? "");
    setTab2FTPBackUpPort(list[0].port ?? "");
    setTab2FTPBackUpProtocol(list[0].protocol === 2 ? "SFTP" : "FTP");
    setTab2FTPBackUpUserName(list[0].userName ?? "");
    setTab2FTPBackUpPassword(DecryptPassword(list[0].password ?? ""));
  };

  const getFileLocationData = async () => {
    const params: FileLocationModel = {
      FTPFolderId: rowData.ftpFolderId,
      BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
      FolderName: undefined,
      AccountName: undefined,
      FileLocationType: undefined,
      Location: undefined,
      ServerName: undefined,
      Port: undefined,
      UserName: undefined,
      Password: undefined,
      AccountId: Number(LocalStorageUtil.getItem("accountId")),
      EnableBackup: false,
      CreatedBy: undefined,
      Active: 1,
      OrderBy: undefined,
      Protocol: undefined,
      LastModifiedDate: undefined,
      CreatedDate: undefined,
      BackUpPath: undefined,
      SearchText: undefined,
      FileFormat: undefined,
      SuperAdmin: undefined,
      ListEmailTemplateModel: undefined,
      RecordCount: undefined,
      ParentFTPFolderId: undefined,
      ContextName: LocalStorageUtil.getItem("contextName") ?? "",
      CurrentPage: undefined,
      NoOfRecords: undefined,
    };
    try {
      const data = await GetFileLocationDataById(params);
      setData(data);
      setFtpFolderId(data?.ftpFolderId);
      set_FileLocationType(data?.fileLocationType);
      setValue(data?.fileLocationType === 2 ? 1 : 0);
      setShowFTPBackupTab(data?.enableBackup === true);

      set_Tab2FTPBackUpCustomer(LocalStorageUtil.getItem("contextName") ?? "");
      setParentFTPUserName(data?.userName);
      setParentFTPPassword(DecryptPassword(data?.password));

      setNetworkBackupTabValues(data);
      setFTPBackupTabValues(data);

      if (
        data?.listEmailTemplateModel !== null &&
        data?.listEmailTemplateModel !== undefined
      ) {
        setBackupDetailsFromList(data.listEmailTemplateModel);
      } else {
        setBackUpftpFolderId(0);
      }
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

// Helper to build main Network Folder model
const buildNetworkFolderModel = () => ({
  FTPFolderId: ftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: parentNetworkDisplayName,
  AccountName: parentNetworkCustomer,
  FileLocationType: "1",
  Location: parentNetworkUNCPath,
  ServerName: undefined,
  Port: undefined,
  UserName: undefined,
  Password: undefined,
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: showNetworkBackupTab,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: null,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: parentNetworkUNCPath,
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to build Network Backup model
const buildNetworkBackupModel = () => ({
  FTPFolderId: backUpftpFolderId === 0 ? null : backUpftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: parentNetworkDisplayName + "backup",
  AccountName: undefined,
  FileLocationType: "1",
  Location: tab1NetworkUNCPath,
  ServerName: undefined,
  Port: undefined,
  UserName: undefined,
  Password: undefined,
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: false,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: undefined,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: "",
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to build FTP Backup model for Network tab
const buildNetworkFTPBackupModel = async () => ({
  FTPFolderId: backUpftpFolderId === 0 ? null : backUpftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: tab1FTPBackUpDisplayName,
  AccountName: undefined,
  FileLocationType: "2",
  Location: tab1FTPBackUpLocation,
  ServerName: tab1FTPBackUpServerName,
  Port: Number(tab1FTPBackUpPort),
  UserName: tab1FTPBackUpUserName,
  Password: await EncryptPassword(tab1FTPBackUpPassword),
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: null,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: tab1FTPBackUpProtocol === "SFTP" ? 2 : 1,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: "",
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to build main FTP model
const buildFTPModel = async () => ({
  FTPFolderId: ftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: parentFTPDisplayName,
  AccountName: parentFTPCustomer,
  FileLocationType: parentFTPProtocol === "SFTP" ? "2" : "1",
  Location: parentFTPLocation,
  ServerName: parentFTPServerName,
  Port: Number(parentFTPPort),
  UserName: parentFTPUserName,
  Password: await EncryptPassword(parentFTPPassword),
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: showFTPBackupTab,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: parentFTPProtocol === "SFTP" ? 2 : 1,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: null,
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to build Network Backup model for FTP tab
const buildFTPNetworkBackupModel = async () => ({
  FTPFolderId: backUpftpFolderId === 0 ? null : backUpftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: parentFTPDisplayName + "backup",
  AccountName: parentFTPCustomer,
  FileLocationType: "1",
  Location: tab2NetworkBackUpUNCPath,
  ServerName: undefined,
  Port: undefined,
  UserName: undefined,
  Password: await EncryptPassword(tab2FTPBackUpPassword),
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: null,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: undefined,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: "",
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to build FTP Backup model for FTP tab
const buildFTPFTPBackupModel = async () => ({
  FTPFolderId: backUpftpFolderId === 0 ? null : backUpftpFolderId,
  BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
  FolderName: tab2FTPBackUpDisplayName,
  AccountName: parentFTPCustomer,
  FileLocationType: parentFTPProtocol === "SFTP" ? "2" : "1",
  Location: tab2FTPBackUpLocation,
  ServerName: tab2FTPBackUpServerName,
  Port: Number(tab2FTPBackUpPort),
  UserName: tab2FTPBackUpUserName,
  Password: await EncryptPassword(tab2FTPBackUpPassword),
  AccountId: Number(LocalStorageUtil.getItem("accountId")),
  EnableBackup: null,
  CreatedBy: Number(LocalStorageUtil.getItem("userId")),
  Active: 1,
  OrderBy: 0,
  Protocol: tab2FTPBackUpProtocol === "SFTP" ? 2 : 1,
  LastModifiedDate: undefined,
  CreatedDate: undefined,
  BackUpPath: "",
  SearchText: undefined,
  FileFormat: undefined,
  SuperAdmin: undefined,
  ListEmailTemplateModel: undefined,
  RecordCount: undefined,
  ParentFTPFolderId: undefined,
  ContextName: LocalStorageUtil.getItem("contextName") ?? "",
  CurrentPage: undefined,
  NoOfRecords: undefined,
});

// Helper to handle API response and navigation
const handleSaveResponse = (data: any) => {
  if (data.status === 202) {
    if (ftpFolderId === undefined || ftpFolderId === 0) {
      showSnackbar("File Location created Successfully");
    } else {
      showSnackbar("File Location updated Successfully");
    }
  } else if (data.status === 200) {
    showSnackbar("Sorry, Display Name already exists", true);
    return;
  } else {
    showSnackbar(
      "File Location entry not updated. Cannot access path: " + parentFTPLocation,
      true
    );
  }
  navigation("/FileLocation");
};

const saveFileLocationData = async (): Promise<void> => {
  setLoading(true);
  const params = new FileLocationContextModel();
  const objFileLocationModel: FileLocationModel[] = [];
  params.ContextName = LocalStorageUtil.getItem("contextName") ?? "";

  try {
    if (value === 0) {
      objFileLocationModel.push(buildNetworkFolderModel());
      if (showNetworkBackupTab) {
        if (valueBackUpNetwork === 0) {
          objFileLocationModel.push(buildNetworkBackupModel());
        } else if (valueBackUpNetwork === 1) {
          objFileLocationModel.push(await buildNetworkFTPBackupModel());
        }
      }
    } else if (value === 1) {
      objFileLocationModel.push(await buildFTPModel());
      if (showFTPBackupTab) {
        if (valueBackUpFTP === 0) {
          objFileLocationModel.push(await buildFTPNetworkBackupModel());
        } else if (valueBackUpFTP === 1) {
          objFileLocationModel.push(await buildFTPFTPBackupModel());
        }
      }
    }

    params.ObjFileLocationModel = objFileLocationModel;
    const data = await SaveFileLocationData(params);
    handleSaveResponse(data);
  } catch (error) {
    showSnackbar(
      "File Location entry not updated. Cannot access path: " + parentFTPLocation,
      true
    );
  } finally {
    setLoading(false);
  }
};


const handleTab1FTPBackUpDisplayNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setTab1FTPBackUpDisplayName(value);

  // Validation: check if backup display name matches parent network display name
  if (
    value.trim() !== "" &&
    value.trim().toLowerCase() === parentNetworkDisplayName.trim().toLowerCase()
  ) {
    setErrors((prev) => ({
      ...prev,
      tab1FTPBackUpDisplayNameError: "Backup display Name cannot be same as parent Network Display Name.",
    }));
  } else {
    setErrors((prev) => ({
      ...prev,
      tab1FTPBackUpDisplayNameError: "",
    }));
  }
};

const handleTab2FTPBackUpDisplayNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setTab2FTPBackUpDisplayName(value);

  // Validation: check if backup display name matches parent FTP display name
  if (
    value.trim() !== "" &&
    value.trim().toLowerCase() === parentFTPDisplayName.trim().toLowerCase()
  ) {
    setErrors((prev) => ({
      ...prev,
      tab2FTPBackUpDisplayNameError: "Backup Display Name cannot be same as parent FTP Display Name.",
    }));
  } else {
    setErrors((prev) => ({
      ...prev,
      tab2FTPBackUpDisplayNameError: "",
    }));
  }
};
// ...existing code...

  return (
    <div>
      {data.ftpFolderId > 0 ? (
        <NavigationBar
          menuTitle="Configuration"
          title="File Location"
          text="File Location - Edit"
        />
      ) : (
        <NavigationBar
          menuTitle="Configuration"
          title="File Location"
          text="File Location - Create New"
        />
      )}
      <Row style={{ margin: "1em" }}>
        <Col xs={12}>
          <div className="rp-main-inner full-width100">
            <div className="form-inp col-sm-12">
              <h4
                className="form-heading"
                style={{ color: "var(--aggrid-text-color)", fontSize: "12px" }}
              >
                File Location Type :
              </h4>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  style={{
                    color: "var(--aggrid-text-color)",
                    width: "40%",
                  }}
                >
                  <Tab label="Network Folder" />
                  <Tab label="FTP Location" />
                </Tabs>
              </Box>

              {/* Main Tab Network Folder Tab 1*/}
              <TabPanel value={value} index={0}>
                <Form>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Customer<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Select
                          name="contextName"
                          disabled={ftpFolderId > 0}
                          value={parentNetworkCustomer}
                          onChange={handleParentNetworkCustomerDropdownChange}
                          isInvalid={!!errors.parentNetworkCustomerError}
                          className="select-dropdown"
                          style={{ fontSize: "11px" }}
                        >
                          {action !== "Edit" && (
                            <option value="">Select customer</option>
                          )}{" "}
                          {accountData.map((account: any) => (
                            <option
                              key={account.id}
                              value={account.contextName}
                            >
                              {account.accountName}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.parentNetworkCustomerError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Display Name<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Display Name"
                          name="displayame"
                          isInvalid={!!errors.parentNetworkDisplayNameError}
                          value={parentNetworkDisplayName}
                          onChange={(e) =>
                            setParentNetworkDisplayName(e.target.value)
                          }
                          required
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentNetworkDisplayNameError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          UNC Path<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter UNC Path"
                          name="uncpath"
                          required
                          value={parentNetworkUNCPath}
                          onChange={(e) =>
                            setParentNetworkUNCPath(e.target.value)
                          }
                          isInvalid={!!errors.parentNetworkUNCPathError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentNetworkUNCPathError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "12px",
                          }}
                        >
                          Backup Folder<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          label="Enable Backup Folder"
                          name="isApiUser"
                          className="input-labels"
                          checked={showNetworkBackupTab}
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                          onChange={handleNetworkBackupTabCheck}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* Backup Folder Tab 1 */}
                  {showNetworkBackupTab && (
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group controlId="formGroupName">
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                              value={valueBackUpNetwork}
                              onChange={handleChangeBackUpNetworkTab}
                              aria-label="basic tabs example"
                              style={{
                                color: "var(--aggrid-text-color)",
                                width: "40%",
                              }}
                            >
                              <Tab label="Network Folder" />
                              <Tab label="FTP Location" />
                            </Tabs>
                          </Box>
                          {/* Tab 1.1 */}
                          <TabPanel value={valueBackUpNetwork} index={0}>
                            <Row className="mb-3">
                              <Col md={3}>
                                <Form.Group controlId="formGroupName">
                                  <Form.Label
                                    className="input-labels"
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Customer<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                  </Form.Label>
                                  <Form.Select
                                    name="contextName"
                                    disabled={ftpFolderId > 0}
                                    value={parentNetworkCustomer}
                                    isInvalid={
                                      !!errors.tab1NetworkBackUpCustomerError
                                    }
                                    onChange={
                                      handleTab1NetworkBackUpDropdownChange
                                    }
                                    className="select-dropdown"
                                    style={{ fontSize: "11px" }}
                                  >
                                    {action !== "Edit" && (
                                      <option value="">Select customer</option>
                                    )}{" "}
                                    {accountData.map((account: any) => (
                                      <option
                                        key={account.id}
                                        value={account.contextName}
                                      >
                                        {account.accountName}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {errors.tab1NetworkBackUpCustomerError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId="formGroupName">
                                  <Form.Label
                                    className="input-labels"
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    UNC Path<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter UNC Path"
                                    name="uncpath"
                                    required
                                    value={tab1NetworkUNCPath}
                                    onChange={(e) =>
                                      setTab1NetworkUNCPath(
                                        e.target.value
                                      )
                                    }
                                    isInvalid={
                                      !!errors.tab1NetworkBackUpUNCPathError
                                    }
                                    className="input-box"
                                    style={{ fontSize: "11px" }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.tab1NetworkBackUpUNCPathError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </TabPanel>
                          {/* Tab 1.2 */}
                          <TabPanel value={valueBackUpNetwork} index={1}>
                            <Form>
                              <Row className="mb-4">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Customer<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="contextName"
                                      disabled={ftpFolderId > 0}
                                      value={parentNetworkCustomer}
                                      onChange={
                                        handleTab1FtpBackUpDropdownChange
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpCustomerError
                                      }
                                      className="select-dropdown"
                                      style={{ fontSize: "11px" }}
                                    >
                                      {action !== "Edit" && (
                                        <option value="">
                                          Select customer
                                        </option>
                                      )}{" "}
                                      {accountData.map((account: any) => (
                                        <option
                                          key={account.id}
                                          value={account.contextName}
                                        >
                                          {account.accountName}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpCustomerError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Display Name<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Display Name"
                                      name="displayame"
                                      required
                                      value={tab1FTPBackUpDisplayName}                                      
                                      onChange={handleTab1FTPBackUpDisplayNameChange}
                                      isInvalid={!!errors.tab1FTPBackUpDisplayNameError}
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpDisplayNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Server Name<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Server Name"
                                      name="ftpserver"
                                      required
                                      value={tab1FTPBackUpServerName}
                                      onChange={(e) =>
                                        setTab1FTPBackUpServerName(
                                          e.target.value
                                        )
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpServerNameError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpServerNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Location<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter the Location"
                                      name="ftpLocation"
                                      value={tab1FTPBackUpLocation}
                                      required
                                      onChange={(e) =>
                                        setTab1FTPBackUpLocation(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpLocationError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpLocationError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Port<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Port"
                                      name="port"
                                      required
                                      value={tab1FTPBackUpPort}
                                      onChange={(e) =>
                                        setTab1FTPBackUpPort(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpPortError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpPortError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Protocol<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="protocolId"
                                      value={tab1FTPBackUpProtocol}
                                      required
                                      onChange={handelTab1FtpProtocolChange}
                                      isInvalid={
                                        !!errors.tab1FTPBackUpProtocolError
                                      }
                                      className="select-dropdown"
                                      style={{ fontSize: "11px" }}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="FTP">FTP</option>
                                      <option value="SFTP">SFTP</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpProtocolError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <h4
                                className="form-heading"
                                style={{
                                  color: "var(--aggrid-text-color)",
                                  fontSize: "12px",
                                }}
                              >
                                LOGIN CREDENTIALS :
                              </h4>

                              <Row className="mb-2">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      User name<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter the User Name"
                                      name="username"
                                      required
                                      value={tab1FTPBackUpUserName}
                                      onChange={(e) =>
                                        setTab1FTPBackUpUserName(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpUserNameError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpUserNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Password<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="password"
                                      placeholder="Enter the Password"
                                      name="password"
                                      required
                                      value={tab1FTPBackUpPassword}
                                      onChange={(e) =>
                                        setTab1FTPBackUpPassword(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab1FTPBackUpPasswordError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab1FTPBackUpPasswordError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Form>
                          </TabPanel>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Form>
              </TabPanel>
              {/* Main Tab FTP Location Tab 2 */}
              <TabPanel value={value} index={1}>
                <Form>
                  <Row className="mb-4">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Customer<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Select
                          name="contextName"
                          disabled={ftpFolderId > 0}
                          value={parentFTPCustomer}
                          onChange={handleParentFTPCustomerDropdownChange}
                          isInvalid={!!errors.parentFTPCustomerError}
                          className="select-dropdown"
                          style={{ fontSize: "11px" }}
                        >
                          {action !== "Edit" && (
                            <option value="">Select customer</option>
                          )}{" "}
                          {accountData.map((account: any) => (
                            <option
                              key={account.id}
                              value={account.contextName}
                            >
                              {account.accountName}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPCustomerError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Display Name<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Display Name"
                          name="displayame"
                          required
                          value={parentFTPDisplayName}
                          onChange={(e) =>
                            setParentFTPDisplayName(e.target.value)
                          }
                          isInvalid={!!errors.parentFTPDisplayNameError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                      </Form.Group>
                      <Form.Control.Feedback type="invalid">
                        {errors.parentFTPDisplayNameError}
                      </Form.Control.Feedback>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Server Name<span style={{ color: "var(--aggrid-text-color)" }} className="required"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Server Name"
                          name="ftpserver"
                          required
                          value={parentFTPServerName}
                          onChange={(e) =>
                            setParentFTPServerName(e.target.value)
                          }
                          isInvalid={!!errors.parentFTPServerNameError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPServerNameError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Location<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter the Location"
                          name="ftpLocation"
                          required
                          value={parentFTPLocation}
                          onChange={(e) => setParentFTPLocation(e.target.value)}
                          isInvalid={!!errors.parentFTPLocationError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPLocationError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-2">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Port<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Port"
                          name="port"
                          required
                          value={parentFTPPort}
                          onChange={(e) => setParentFTPPort(e.target.value)}
                          isInvalid={!!errors.parentFTPPortError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPPortError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Protocol<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Select
                          name="protocolId"
                          required
                          value={parentFTPProtocol}
                          onChange={handelParentProtocolChange}
                          isInvalid={!!errors.parentFTPProtocolError}
                          className="select-dropdown"
                          style={{ fontSize: "11px" }}
                        >
                          <option value="Select">Select</option>
                          <option value="FTP">FTP</option>
                          <option value="SFTP">SFTP</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPProtocolError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h4
                    className="form-heading"
                    style={{
                      color: "var(--aggrid-text-color)",
                      fontSize: "12px",
                    }}
                  >
                    LOGIN CREDENTIALS :
                  </h4>

                  <Row className="mb-2">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          User name<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter the User Name"
                          name="username"
                          required
                          value={parentFTPUserName}
                          onChange={(e) => setParentFTPUserName(e.target.value)}
                          isInvalid={!!errors.parentFTPUserNameError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPUserNameError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                        >
                          Password<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter the Password"
                          name="password"
                          required
                          value={parentFTPPassword}
                          onChange={(e) => setParentFTPPassword(e.target.value)}
                          isInvalid={!!errors.parentFTPPasswordError}
                          className="input-box"
                          style={{ fontSize: "11px" }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.parentFTPPasswordError}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Backup Folder Tab 2 */}
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="formGroupName">
                        <Form.Label
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "12px",
                          }}
                        >
                          Backup Folder<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          label="Enable Backup Folder"
                          name="isApiUser"
                          className="input-labels"
                          style={{
                            color: "var(--aggrid-text-color)",
                            fontSize: "11px",
                          }}
                          checked={showFTPBackupTab}
                          onChange={handleFTPBackupTabCheck}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {showFTPBackupTab && (
                    <Row className="mb-3">
                      <Col md={12}>
                        <Form.Group controlId="formGroupName">
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                              value={valueBackUpFTP}
                              onChange={handleChangeBackUpFTPTab}
                              aria-label="basic tabs example"
                              style={{
                                color: "var(--aggrid-text-color)",
                                width: "40%",
                              }}
                            >
                              <Tab label="Network Folder" />
                              <Tab label="FTP Location" />
                            </Tabs>
                          </Box>
                          {/* Tab 2.1 */}
                          <TabPanel value={valueBackUpFTP} index={0}>
                            <Row className="mb-3">
                              <Col md={3}>
                                <Form.Group controlId="formGroupName">
                                  <Form.Label
                                    className="input-labels"
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Customer<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                  </Form.Label>
                                  <Form.Select
                                    name="contextName"
                                    disabled={ftpFolderId > 0}
                                    value={parentFTPCustomer}
                                    onChange={
                                      handleTab2NetworkBackUpDropdownChange
                                    }
                                    isInvalid={
                                      !!errors.tab2NetworkBackUpCustomerError
                                    }
                                    className="select-dropdown"
                                    style={{ fontSize: "11px" }}
                                  >
                                    {action !== "Edit" && (
                                      <option value="">Select customer</option>
                                    )}{" "}
                                    {accountData.map((account: any) => (
                                      <option
                                        key={account.id}
                                        value={account.contextName}
                                      >
                                        {account.accountName}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {errors.tab2NetworkBackUpCustomerError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group controlId="formGroupName">
                                  <Form.Label
                                    className="input-labels"
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    UNC Path<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter UNC Path"
                                    name="uncpath"
                                    value={tab2NetworkBackUpUNCPath}
                                    required
                                    onChange={(e) =>
                                      setTab2NetworkBackUpUNCPath(
                                        e.target.value
                                      )
                                    }
                                    isInvalid={
                                      !!errors.tab2NetworkBackUpUNCPathError
                                    }
                                    className="input-box"
                                    style={{ fontSize: "11px" }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.tab2NetworkBackUpUNCPathError}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </TabPanel>
                          {/* Tab 2.2 */}
                          <TabPanel value={valueBackUpFTP} index={1}>
                            <Form>
                              <Row className="mb-4">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Customer<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="contextName"
                                      disabled={ftpFolderId > 0}
                                      value={parentFTPCustomer}
                                      onChange={
                                        handleTab2FtpBackUpDropdownChange
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpCustomerError
                                      }
                                      className="select-dropdown"
                                      style={{ fontSize: "11px" }}
                                    >
                                      {action !== "Edit" && (
                                        <option value="">
                                          Select customer
                                        </option>
                                      )}{" "}
                                      {accountData.map((account: any) => (
                                        <option
                                          key={account.id}
                                          value={account.contextName}
                                        >
                                          {account.accountName}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpCustomerError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Display Name<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Display Name"
                                      name="displayame"
                                      required
                                      value={tab2FTPBackUpDisplayName}
                                      onChange={handleTab2FTPBackUpDisplayNameChange}
                                      isInvalid={!!errors.tab2FTPBackUpDisplayNameError}
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpDisplayNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Server Name<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Server Name"
                                      name="ftpserver"
                                      required
                                      value={tab2FTPBackUpServerName}
                                      onChange={(e) =>
                                        setTab2FTPBackUpServerName(
                                          e.target.value
                                        )
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpServerNameError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpServerNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Location<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter the Location"
                                      name="ftpLocation"
                                      required
                                      value={tab2FTPBackUpLocation}
                                      onChange={(e) =>
                                        setTab2FTPBackUpLocation(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpLocationError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpLocationError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Port<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter Port"
                                      name="port"
                                      required
                                      value={tab2FTPBackUpPort}
                                      onChange={(e) =>
                                        setTab2FTPBackUpPort(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpPortError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpPortError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Protocol<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="protocolId"
                                      required
                                      onChange={handelTab2FtpProtocolChange}
                                      value={tab2FTPBackUpProtocol}
                                      isInvalid={
                                        !!errors.tab2FTPBackUpProtocolError
                                      }
                                      className="select-dropdown"
                                      style={{ fontSize: "11px" }}
                                    >
                                      <option value="Select">Select</option>
                                      <option value="FTP">FTP</option>
                                      <option value="SFTP">SFTP</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpProtocolError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <h4
                                className="form-heading"
                                style={{
                                  color: "var(--aggrid-text-color)",
                                  fontSize: "12px",
                                }}
                              >
                                LOGIN CREDENTIALS :
                              </h4>

                              <Row className="mb-2">
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      User name<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter the User Name"
                                      name="username"
                                      required
                                      value={tab2FTPBackUpUserName}
                                      onChange={(e) =>
                                        setTab2FTPBackUpUserName(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpUserNameError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpUserNameError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md={3}>
                                  <Form.Group controlId="formGroupName">
                                    <Form.Label
                                      className="input-labels"
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        fontSize: "11px",
                                      }}
                                    >
                                      Password<span className="required" style={{ color: "var(--aggrid-text-color)" }}> *</span>
                                    </Form.Label>
                                    <Form.Control
                                      type="password"
                                      placeholder="Enter the Password"
                                      name="password"
                                      required
                                      value={tab2FTPBackUpPassword}
                                      onChange={(e) =>
                                        setTab2FTPBackUpPassword(e.target.value)
                                      }
                                      isInvalid={
                                        !!errors.tab2FTPBackUpPasswordError
                                      }
                                      className="input-box"
                                      style={{ fontSize: "11px" }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {errors.tab2FTPBackUpPasswordError}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Form>
                          </TabPanel>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Form>
              </TabPanel>
            </div>
            <div
              style={{
                width: "98%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
                marginBottom: "15px",
              }}
            >
              <Button className="update-button" onClick={handleCreate}>
                {data.ftpFolderId > 0 ? "Update" : "Create New"}
              </Button>
              <Button className="cancel-button" onClick={handelCancel}>
                Cancel
              </Button>
            </div>
            <Dialog
              open={confirmDialogOpen}
              onClose={() => handleConfirmDialogClose(false)}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle
                style={{
                  backgroundColor: "var(--primary-color)",
                  color: "var(--aggrid-text-color)",
                  fontSize: "16px",
                  fontWeight: 500,
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                File Location - {data.ftpFolderId > 0 ? "Update" : "Create New"}{" "}
              </DialogTitle>
              <DialogContent
                style={{
                  fontSize: "12px",
                  marginTop: "20px",
                  padding: "1px 24px",
                }}
              >
                Are you sure you want to Cancel?
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleConfirmDialogClose(true)}
                  color="primary"
                  style={{
                    fontSize: "14px",
                    color: "var(--aggrid-text-color)",
                    backgroundColor: "var(--primary-color)",
                    height: "2.1em",
                    padding: "4px 6px",
                  }}
                >
                  Yes
                </Button>
                <Button
                  onClick={() => handleConfirmDialogClose(false)}
                  color="primary"
                  style={{
                    fontSize: "14px",
                    color: "var(--aggrid-text-color)",
                    backgroundColor: "var(--primary-color)",
                    height: "2.1em",
                    padding: "4px 6px",
                  }}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CreateNew;
